import React from "react";
import { Bio as Wrap } from "./Details/styled";
import CroppedText from "_c/CroppedText";

const Bio = ({ value, placeholder }) => {
  if (value) return <CroppedText Component={Wrap} limit={255} text={value} />;
  return <Wrap>{placeholder}</Wrap>;
};

export default Bio;
